module.exports = __webpack_public_path__ + "img/ionut_caras.d52a7d91.jpg";